import { Chip } from '@mui/material';

interface ConceptTopicChipProps {
  label: string;
  emoji?: string;
}

export const ConceptTopicChip = ({
  label,
  emoji = '📘',
}: ConceptTopicChipProps) => (
  <Chip
    label={`${emoji} ${label}`}
    size="small"
    sx={{
      mt: 1.25,
      bgcolor: '#f1f5f9',
      color: '#475569',
      fontSize: 11,
      fontWeight: 500,
      height: 24,
      '& .MuiChip-label': {
        px: 1,
      },
    }}
  />
);
